jQuery_T4NT(document).ready(function ($) {
  /**
  *  Variant selection changed
  *  data-variant-toggle="{{ variant.id }}"
  */
  $(document).on("variant:changed", function (evt) {
  });
});
// Fix for quantity buttons on product pages and cart
document.body.addEventListener("click", function (e) {
  if (e.target.closest("[data-increase-qty]") || e.target.closest("[data-decrease-qty]")) {
    var btn = e.target.closest("button");

    var wrapper = btn.closest("[data-quantity-wrapper]");
    if (wrapper) {
      var input = wrapper.querySelector("[data-quantity-value]");
      if (input) {
        var currentVal = parseInt(input.value) || 1;
        var step = parseInt(input.getAttribute("step")) || 1;
        var min = parseInt(input.getAttribute("min")) || 1;
        var max = parseInt(input.getAttribute("max")) || 9999;
        var newVal = currentVal;

        if (btn.hasAttribute("data-increase-qty")) {
          if (currentVal + step <= max) {
            newVal = currentVal + step;
          }
        } else if (btn.hasAttribute("data-decrease-qty")) {
          if (currentVal - step >= min) {
            newVal = currentVal - step;
          }
        }

        if (newVal !== currentVal) {
          input.value = newVal;
          input.dispatchEvent(new window.Event("change", { bubbles: true }));
          input.dispatchEvent(new window.Event("input", { bubbles: true }));
          if (typeof jQuery_T4NT !== "undefined") {
            jQuery_T4NT(input).trigger("change");
          }

          // Update cart price when quantity changes in cart/mini-cart
          if (btn.closest('.t4s-cartPage__form') || btn.closest('.t4s-drawer') || btn.closest('.t4s-mini_cart')) {
            var lineItemKey = input.getAttribute("data-id");
            if (lineItemKey) {
              // Show loading state
              var cartWrapper = btn.closest('#t4s-mini_cart') || btn.closest('.t4s-cartPage__form');
              if (cartWrapper) {
                cartWrapper.classList.add('is--contentUpdate');
              }

              clearTimeout(window.cartReloadTimeout);
              window.cartReloadTimeout = setTimeout(function () {
                // Use Shopify's /cart/change.js API with the line item key and new quantity
                fetch((window.T4Sroutes && window.T4Sroutes.cart_change_url) || '/cart/change.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                  },
                  body: JSON.stringify({
                    id: lineItemKey,
                    quantity: newVal
                  })
                }).then(function (response) {
                  return response.json();
                }).then(function (cart) {
                  // Reload to reflect updated prices and quantities
                  window.location.reload();
                }).catch(function (err) {
                  console.error('Cart update failed:', err);
                  window.location.reload();
                });
              }, 400);
            }
          }
        }
      }
    }
  }

  // Fix for cart remove buttons
  var removeBtn = e.target.closest("[data-cart-remove]");
  if (removeBtn) {
    e.preventDefault();
    var lineItemKey = removeBtn.getAttribute("data-id");
    if (lineItemKey) {
      var cartWrapper = removeBtn.closest('#t4s-mini_cart') || removeBtn.closest('.t4s-cartPage__form') || removeBtn.closest('.t4s-drawer');
      if (cartWrapper) {
        cartWrapper.classList.add('is--contentUpdate');
      }

      fetch((window.T4Sroutes && window.T4Sroutes.cart_change_url) || '/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: lineItemKey,
          quantity: 0
        })
      }).then(function (response) {
        return response.json();
      }).then(function (cart) {
        window.location.reload();
      }).catch(function (err) {
        console.error('Cart remove failed:', err);
        window.location.reload();
      });
    }
  }

  // Fix for 'Click to enlarge' zoom button or direct click on main product image
  if (window.isTriggeringPswp) return;

  var zoomBtn = e.target.closest("[data-pr-trigger-pswp]");
  var mainImageClick = e.target.closest("[data-t4s-gallery--open]");

  if (zoomBtn || (mainImageClick && mainImageClick.classList.contains("is-pswp-disable"))) {
    e.preventDefault();
    
    var container = (zoomBtn || mainImageClick).closest(".t4s-product__one_media") || 
                    (zoomBtn || mainImageClick).closest(".t4s-product__media-wrapper") || 
                    (zoomBtn || mainImageClick).closest(".t4s-row__product") || 
                    document.body;

    var gallery = container.querySelector("[data-t4s-gallery]") || container;
    
    var activeImageBtn = mainImageClick || gallery.querySelector(".is-selected [data-t4s-gallery--open]") || gallery.querySelector("[data-t4s-gallery--open]");
    
    if (activeImageBtn) {
      var hasDisableClassImg = activeImageBtn.classList.contains("is-pswp-disable");
      var hasDisableClassGal = gallery instanceof HTMLElement && gallery.classList.contains("is-pswp-disable");

      if (hasDisableClassImg) activeImageBtn.classList.remove("is-pswp-disable");
      if (hasDisableClassGal) gallery.classList.remove("is-pswp-disable");

      window.isTriggeringPswp = true;
      activeImageBtn.click();
      window.isTriggeringPswp = false;

      if (hasDisableClassImg) activeImageBtn.classList.add("is-pswp-disable");
      if (hasDisableClassGal) gallery.classList.add("is-pswp-disable");
    }
  }
});

/**
 * ============================================================
 * Combined iOS Safari Touch Fix
 * ============================================================
 * Unified touchstart/touchmove/touchend handler for:
 * 1. Drawer triggers (cart, menu, login, search)
 * 2. Kwikpass login/account buttons
 * 3. Drawer close buttons
 *
 * Uses a single set of listeners instead of duplicates.
 */
(function () {
  'use strict';

  // Shared touch tracking (one set of listeners for all handlers)
  var touchStartX = 0;
  var touchStartY = 0;
  var isTouchMove = false;

  document.addEventListener('touchstart', function (e) {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    isTouchMove = false;
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    var dx = Math.abs(e.touches[0].clientX - touchStartX);
    var dy = Math.abs(e.touches[0].clientY - touchStartY);
    if (dx > 8 || dy > 8) {
      isTouchMove = true;
    }
  }, { passive: true });

  /**
   * Attempt to open a drawer by its CSS selector ID.
   */
  function openDrawer(drawerId) {
    var drawer = document.querySelector(drawerId);
    if (!drawer) return;

    if (window.T4S && typeof window.T4S.openDrawer === 'function') {
      window.T4S.openDrawer(drawerId);
      return;
    }

    var trigger = document.querySelector('[data-drawer-open][data-drawer-options*="' + drawerId.replace('#', '') + '"]') ||
                  document.querySelector('[data-drawer-options*="' + drawerId.replace('#', '') + '"]');
    if (trigger) {
      trigger.click();
      return;
    }

    var isHidden = drawer.getAttribute('aria-hidden') !== 'false';
    if (isHidden) {
      drawer.setAttribute('aria-hidden', 'false');
      drawer.classList.remove('t4s-dn');
      var overlay = document.querySelector('.t4s-overlay') || createOverlay();
      if (overlay) {
        overlay.classList.add('is--visible');
        overlay.setAttribute('aria-hidden', 'false');
      }
      document.documentElement.classList.add('t4s-drawer--is-open');
    }
  }

  function createOverlay() {
    var overlay = document.createElement('div');
    overlay.className = 't4s-overlay';
    overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:468;display:none;';
    document.body.appendChild(overlay);
    overlay.addEventListener('click', function () {
      closeAllDrawers();
    });
    return overlay;
  }

  function closeAllDrawers() {
    document.querySelectorAll('.t4s-drawer[aria-hidden="false"]').forEach(function (d) {
      d.setAttribute('aria-hidden', 'true');
    });
    document.documentElement.classList.remove('t4s-drawer--is-open');
    var overlay = document.querySelector('.t4s-overlay');
    if (overlay) {
      overlay.classList.remove('is--visible');
      overlay.setAttribute('aria-hidden', 'true');
    }
  }

  /**
   * Single touchend handler for ALL tap-based interactions
   */
  document.addEventListener('touchend', function (e) {
    if (isTouchMove) return;

    var target = e.target;

    // ----- CART SIDEBAR -----
    var cartTrigger = target.closest('[data-drawer-open][data-drawer-options*="t4s-mini_cart"]') ||
                      target.closest('[data-drawer-delay-][data-drawer-options*="t4s-mini_cart"]') ||
                      target.closest('a[href][data-drawer-options*="t4s-mini_cart"]');
    if (cartTrigger) {
      e.preventDefault();
      openDrawer('#t4s-mini_cart');
      return;
    }

    // ----- MENU DRAWER -----
    var menuTrigger = target.closest('[data-menu-drawer]') ||
                      target.closest('[data-drawer-options*="t4s-menu-drawer"]');
    if (menuTrigger) {
      e.preventDefault();
      openDrawer('#t4s-menu-drawer');
      return;
    }

    // ----- LOGIN / REGISTER SIDEBAR -----
    var loginTrigger = target.closest('[data-drawer-delay-][data-drawer-options*="t4s-login-sidebar"]') ||
                       target.closest('[data-drawer-options*="t4s-login-sidebar"]') ||
                       target.closest('a[href][data-drawer-options*="t4s-login-sidebar"]');
    if (loginTrigger) {
      e.preventDefault();
      openDrawer('#t4s-login-sidebar');
      return;
    }

    // ----- SEARCH SIDEBAR -----
    var searchTrigger = target.closest('[data-drawer-delay-][data-drawer-options*="t4s-search-hidden"]') ||
                        target.closest('[data-drawer-options*="t4s-search-hidden"]');
    if (searchTrigger) {
      e.preventDefault();
      openDrawer('#t4s-search-hidden');
      return;
    }

    // ----- DRAWER CLOSE BUTTONS -----
    var closeBtn = target.closest('[data-drawer-close]') ||
                   target.closest('.t4s-drawer-menu__close') ||
                   target.closest('.t4s-drawer__close');
    if (closeBtn) {
      var parentDrawer = closeBtn.closest('.t4s-drawer');
      if (parentDrawer) {
        parentDrawer.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('t4s-drawer--is-open');
      }
      return;
    }

    // ----- KWIKPASS LOGIN -----
    var kpLoginBtn = target.closest('#kplogin') ||
                     target.closest('[onclick*="handleKpAndShopifyLogin"]');
    if (kpLoginBtn) {
      e.preventDefault();
      if (typeof window.handleKpAndShopifyLogin === 'function') {
        window.handleKpAndShopifyLogin();
      } else {
        window.location.href = '/account/login';
      }
      return;
    }

    // ----- KWIKPASS ACCOUNT -----
    var kpDashboard = target.closest('[onclick*="kpHandleLogin"]');
    if (kpDashboard) {
      e.preventDefault();
      var onclickAttr = kpDashboard.getAttribute('onclick') || '';
      var match = onclickAttr.match(/kpHandleLogin\(['"]([^'"]+)['"]\)/);
      if (match && match[1]) {
        if (typeof window.kpHandleLogin === 'function') {
          window.kpHandleLogin(match[1]);
        } else {
          window.location.href = match[1];
        }
      }
      return;
    }

    // ----- KWIKPASS LOGOUT -----
    var kpLogout = target.closest('[onclick*="handleLogout"]');
    if (kpLogout) {
      e.preventDefault();
      if (typeof window.handleLogout === 'function') {
        window.handleLogout();
      } else {
        window.location.href = '/account/logout';
      }
      return;
    }

  }, { passive: false });

  /**
   * Fix CSS for iOS tap targets — ensures cursor:pointer + touch-action
   */
  function fixTapTargets() {
    var triggers = document.querySelectorAll(
      '[data-drawer-delay-], [data-drawer-open], [data-menu-drawer], ' +
      '#kplogin, #kpaccount, #kplogin a, #kpaccount a, ' +
      '[onclick*="handleKpAndShopifyLogin"], [onclick*="kpHandleLogin"], [onclick*="handleLogout"]'
    );
    triggers.forEach(function (el) {
      el.style.cursor = 'pointer';
      el.style.webkitTapHighlightColor = 'transparent';
      el.style.touchAction = 'manipulation';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixTapTargets);
  } else {
    fixTapTargets();
  }

  document.addEventListener('scripts:lazyload', fixTapTargets);

})();

/* ------------------------------------------------------------------
   Product gallery safety net (added 2026-10-29).
   Symptom: on some product pages (first seen on Longevity Fuel at desktop widths) the main
   image stayed blank: the lazy loader unveiled the first slide before the slider had laid it
   out (width 0), so it dropped the lazy class without ever building the responsive srcset,
   and the slider measured its viewport at 0px and never re-measured.
   Fix: after load, re-queue such stuck images and nudge the slider to re-measure. Stops on its own.
------------------------------------------------------------------- */
(function () {
  function fixProductGallery() {
    var group = document.querySelector('[data-product-single-media-group]');
    if (!group) return true;
    var done = true;
    group.querySelectorAll('img.t4s-lz--fadeIn:not(.lazyloadt4s):not(.lazyloadt4sed)').forEach(function (img) {
      if (!img.getAttribute('srcset') && img.getBoundingClientRect().width > 0) {
        img.classList.add('lazyloadt4s');
        done = false;
      }
    });
    var viewport = group.querySelector('.flickityt4s-viewport');
    if (viewport && parseFloat(viewport.style.height || '0') < 10 && group.getBoundingClientRect().width > 0) {
      window.dispatchEvent(new Event('resize'));
      done = false;
    }
    return done;
  }
  var runs = 0;
  function tick() {
    var done = fixProductGallery();
    if (!done && ++runs < 10) setTimeout(tick, 600);
  }
  function start() { setTimeout(tick, 400); }
  if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
})();
